import { Flex, Label, Link } from '@fareye/ui'
import React from 'react';

function Forbidden(props: any) {
    return (
        <Flex
          column
          width={1}
          alignItemsCenter
          justifyContentCenter
          style={{ height: '100vh' }}
        >
          <Label variant="h1">You are not authorized to access this page</Label>
          <Flex alignItemsCenter p={4}>
            Visit
            <Link variant="link" to="/">
              Homepage
            </Link>
          </Flex>
        </Flex>
      )
}

export default Forbidden
